import NSJobComponent from './job.js';

import NSSpreadsheetOnboardingCompanies from './@ns/spreadsheet/onboarding-companies.js';

// Company jobs
import NSCompanyFindOrCreate from './@ns/company/find-or-create.js';
import NSCompanyJoin from './@ns/company/join.js';
import NSSelectCompanyToTransferNodeCash from './@ns/company/node-cash/select-company.js';
import NSTransferNodeCashToCompany from './@ns/company/node-cash/transfer.js';
import NSCompanyCHValidation from './@ns/company/companies-house/validation.js';
import NSCompanyTurnoverConfirm from './@ns/company/turnover/confirm.js';
import NSCompanyTurnoverDeclaration from './@ns/company/turnover/declaration.js';
import NSCompanyTurnoverDisputeReview from './@ns/company/turnover/dispute-review.js';
import NSCompanyTurnoverConfirmedNotice from './@ns/company/turnover/confirmed-notice.js';
import NSCompanyHMRCValidation from './@ns/company/hmrc/validation.js';
// Placeholder card until the HMRC trust-score UI work replaces it
import NSCompanyHMRCTrustScoreReview from './@ns/company/hmrc/trust-score-review.js';
import NSCompanyBankValidation from './@ns/company/bank/validation.js';
import NSCompanyBankTransfer from './@ns/company/bank/transfer.js';
import NSCompanyBankVerify from './@ns/company/bank/verify.js';
import NSCompanyConnectRequest from './@ns/company/connect/request.js';
import NSCompanyConnectApprove from './@ns/company/connect/approve.js';
import NSCommercialRelationshipReview from './@ns/company/relationship-review.js';
import NSCompanyRelationshipEnd from './@ns/company/relationship-end.js';
import NSCompanyRelationshipEdit from './@ns/company/relationship-edit.js';
import NSCompanyNetworkAccessApprove from './@ns/company/network-access/approve.js';
import NSCompanyDataAccessAnswer from './@ns/company/data-access/answer.js';
import NSCompanyDataOfferAnswer from './@ns/company/data-access/offer-answer.js';
import NSTask from './@ns/task.js';
import NSForm from './@ns/form.js';
import NSApproval from './@ns/approval.js';
import NSChecklist from './@ns/checklist.js';
import NSDataSelectRecord from './@ns/data-select-record.js';
import NSDataEditRecord from './@ns/data-edit-record.js';
import NSDataAddRecord from './@ns/data-add-record.js';
import NSOnboardCompanyDelegate from './@ns/company/onboard-company-delegate.js';
import NSAcceptCompanyRequestToJoin from './@ns/company/accept-company-request-to-join.js';
import NSInviteCompanyEmployees from './@ns/company/invite-company-employees.js';
import NSReportingTo from './@ns/company/reporting-to.js';
import NSVerifyStaffClaims from './@ns/company/verify-staff-claims.js';

import NSLambdaErrorDebug from './@ns/lambda-error-debug.js';
import NSOnboardingPayment from './@ns/onboarding-payment.js';
import NSCancelSubscription from './@ns/subscription/cancel.js';
import NSReactivateSubscription from './@ns/subscription/reactivate.js';
import NSUpdateSubscriptionPlan from './@ns/subscription/update-plan.js';
import NSAddSubscriptionCard from './@ns/subscription/add-card.js';
import NSSelectSubscriptionCard from './@ns/subscription/select-card.js';
import NSAuthoriseSubscriptionCardUse from './@ns/subscription/authorise-card-use.js';
import NSAuthoriseSubscriptionCardUseFeedback from './@ns/subscription/authorise-card-use-feedback.js';
import NSCreatePublicLedgerAccount from './@ns/public-ledger/account/create.js';
import NSRecoverPublicLedgerAccountKeys from './@ns/public-ledger/account/recover-keys.js';
import NSInviteUser from './@ns/invite-user.js';

// nodeStream support jobs (placeholder cards until the HMRC trust-score UI work replaces them)
import NSSupportBehaviourScoreFailing from './@ns/support/behaviour-score-failing.js';
import NSSupportCompaniesHouseFailing from './@ns/support/companies-house-failing.js';
import NSSupportCompaniesHouseNotFound from './@ns/support/companies-house-not-found.js';
import NSSupportHMRCNoReviewer from './@ns/support/hmrc-no-reviewer.js';
import NSSupportHMRCVatNameReview from './@ns/support/hmrc-vat-name-review.js';
import NSSupportTrustScoreReview from './@ns/support/trust-score-review.js';
import NSSupportAutopayCardDetachFailed from './@ns/support/autopay-card-detach-failed.js';

import NSCollectPublicLedgerSignature from './@ns/public-ledger/collect-signature.js';
import NSUpdatePublicLedgerConfigKey from './@ns/public-ledger/update-config-key.js';
import NSUpdatePublicLedgerTopicKey from './@ns/public-ledger/update-topic-key.js';
import NSPublicLedgerPlatformTopUp from './@ns/public-ledger/platform-top-up.js';
import NSPublicLedgerBuyCredits from './@ns/public-ledger/credits/buy.js';
import NSPublicLedgerCreditTransferFailed from './@ns/public-ledger/credit-transfer-failed.js';
import NSPublicLedgerAutopayCardChangeFee from './@ns/public-ledger/autopay-card-change-fee.js';
import NSPublicLedgerAutopayFeeOverCap from './@ns/public-ledger/autopay-fee-over-cap.js';
import NSPublicLedgerCreditExtraCharge from './@ns/public-ledger/credit-extra-charge.js';
import NSPublicLedgerFundTestCompany from './@ns/public-ledger/fund-test-company.js';
import NSPublicLedgerAutoPaymentsSetup from './@ns/public-ledger/auto-payments/setup.js';
import NSPublicLedgerSignMismatch from './@ns/public-ledger/sign-mismatch.js';
import NSPublicLedgerAutoPaymentsChargeFailed from './@ns/public-ledger/auto-payments/charge-failed.js';
import NSPublicLedgerAutoPaymentsLimitReached from './@ns/public-ledger/auto-payments/limit-reached.js';
import NSPublicLedgerAutoPaymentsChangeTarget from './@ns/public-ledger/auto-payments/change-target.js';
import NSPublicLedgerAutoPaymentsRaiseTarget from './@ns/public-ledger/auto-payments/raise-target.js';
import NSPublicLedgerAutoPaymentsResignAllowance from './@ns/public-ledger/auto-payments/resign-allowance.js';
import NSPublicLedgerAutoPaymentsChangeAmounts from './@ns/public-ledger/auto-payments/change-amounts.js';
import NSPublicLedgerAutoPaymentsChangeCard from './@ns/public-ledger/auto-payments/change-card.js';
import NSPublicLedgerAutoPaymentsStop from './@ns/public-ledger/auto-payments/stop.js';

// Create a map of job names to classes that extend NSJobComponent
const jobs: { [key: string]: typeof NSJobComponent } = {
  '@ns/spreadsheet-onboarding-companies': NSSpreadsheetOnboardingCompanies,

  // Company Jobs
  '@ns/company-connect-request': NSCompanyConnectRequest,
  '@ns/company-connect-approve': NSCompanyConnectApprove,
  '@ns/company-network-access-approve': NSCompanyNetworkAccessApprove,
  '@ns/company-data-access-answer': NSCompanyDataAccessAnswer,
  '@ns/company-data-offer-answer': NSCompanyDataOfferAnswer,
  '@ns/task': NSTask,
  '@ns/form': NSForm,
  '@ns/approval': NSApproval,
  '@ns/checklist': NSChecklist,
  '@ns/data-select-record': NSDataSelectRecord,
  '@ns/data-edit-record': NSDataEditRecord,
  '@ns/data-add-record': NSDataAddRecord,
  '@ns/commercial-relationship-review': NSCommercialRelationshipReview,
  '@ns/company-relationship-end': NSCompanyRelationshipEnd,
  '@ns/company-relationship-edit': NSCompanyRelationshipEdit,
  '@ns/company-find-or-create': NSCompanyFindOrCreate,
  '@ns/company-join': NSCompanyJoin,
  '@ns/company-ch-validation': NSCompanyCHValidation,
  '@ns/company-turnover-confirmation': NSCompanyTurnoverConfirm,
  '@ns/company-turnover-declaration': NSCompanyTurnoverDeclaration,
  '@ns/company-turnover-dispute-review': NSCompanyTurnoverDisputeReview,
  '@ns/company-turnover-confirmed-notice': NSCompanyTurnoverConfirmedNotice,
  '@ns/company-hmrc-validation': NSCompanyHMRCValidation,
  '@ns/company-hmrc-trust-score-review': NSCompanyHMRCTrustScoreReview,
  '@ns/company-bank-validation': NSCompanyBankValidation,
  '@ns/company-bank-transfer': NSCompanyBankTransfer,
  '@ns/company-bank-verify': NSCompanyBankVerify,
  '@ns/select-company-to-transfer-node-cash': NSSelectCompanyToTransferNodeCash,
  '@ns/transfer-node-cash-to-company': NSTransferNodeCashToCompany,
  '@ns/onboard-company-delegate': NSOnboardCompanyDelegate,
  '@ns/accept-company-request-to-join': NSAcceptCompanyRequestToJoin,
  '@ns/invite-company-employees': NSInviteCompanyEmployees,
  '@ns/reporting-to': NSReportingTo,
  '@ns/verify-staff-claims': NSVerifyStaffClaims,

  '@ns/lambda-error-debug': NSLambdaErrorDebug,
  '@ns/onboarding-payment': NSOnboardingPayment,
  '@ns/cancel-subscription': NSCancelSubscription,
  '@ns/reactivate-subscription': NSReactivateSubscription,
  '@ns/update-subscription-plan': NSUpdateSubscriptionPlan,
  '@ns/add-subscription-card': NSAddSubscriptionCard,
  '@ns/select-subscription-card': NSSelectSubscriptionCard,
  '@ns/authorise-subscription-card-use': NSAuthoriseSubscriptionCardUse,
  '@ns/authorise-subscription-card-use-feedback': NSAuthoriseSubscriptionCardUseFeedback,
  '@ns/create-public-ledger-account': NSCreatePublicLedgerAccount,
  '@ns/recover-public-ledger-account-keys': NSRecoverPublicLedgerAccountKeys,
  '@ns/invite-user': NSInviteUser,

  // nodeStream support jobs
  '@ns/support-behaviour-score-failing': NSSupportBehaviourScoreFailing,
  '@ns/support-companies-house-failing': NSSupportCompaniesHouseFailing,
  '@ns/support-companies-house-not-found': NSSupportCompaniesHouseNotFound,
  '@ns/support-hmrc-no-reviewer': NSSupportHMRCNoReviewer,
  '@ns/support-hmrc-vat-name-review': NSSupportHMRCVatNameReview,
  '@ns/support-trust-score-review': NSSupportTrustScoreReview,
  '@ns/support-autopay-card-detach-failed': NSSupportAutopayCardDetachFailed,

  '@ns/collect-public-ledger-signature': NSCollectPublicLedgerSignature,
  '@ns/update-public-ledger-config-key': NSUpdatePublicLedgerConfigKey,
  '@ns/update-public-ledger-topic-key': NSUpdatePublicLedgerTopicKey,
  '@ns/public-ledger-platform-top-up': NSPublicLedgerPlatformTopUp,
  '@ns/public-ledger-buy-credits': NSPublicLedgerBuyCredits,
  '@ns/public-ledger-credit-transfer-failed': NSPublicLedgerCreditTransferFailed,
  '@ns/public-ledger-autopay-card-change-fee': NSPublicLedgerAutopayCardChangeFee,
  '@ns/public-ledger-autopay-fee-over-cap': NSPublicLedgerAutopayFeeOverCap,
  '@ns/public-ledger-credit-extra-charge': NSPublicLedgerCreditExtraCharge,
  '@ns/public-ledger-fund-test-company': NSPublicLedgerFundTestCompany,
  '@ns/public-ledger-auto-payments-setup': NSPublicLedgerAutoPaymentsSetup,
  '@ns/public-ledger-sign-mismatch': NSPublicLedgerSignMismatch,
  '@ns/public-ledger-auto-payments-charge-failed': NSPublicLedgerAutoPaymentsChargeFailed,
  '@ns/public-ledger-auto-payments-limit-reached': NSPublicLedgerAutoPaymentsLimitReached,
  '@ns/public-ledger-auto-payments-change-target': NSPublicLedgerAutoPaymentsChangeTarget,
  '@ns/public-ledger-auto-payments-raise-target': NSPublicLedgerAutoPaymentsRaiseTarget,
  '@ns/public-ledger-auto-payments-resign-allowance': NSPublicLedgerAutoPaymentsResignAllowance,
  '@ns/public-ledger-auto-payments-change-amounts': NSPublicLedgerAutoPaymentsChangeAmounts,
  '@ns/public-ledger-auto-payments-change-card': NSPublicLedgerAutoPaymentsChangeCard,
  '@ns/public-ledger-auto-payments-stop': NSPublicLedgerAutoPaymentsStop,
};

// Development and staging only, like the gallery: the card of the workflow that proves a job's company public ledger
// message (stage 9, OQ2), whose schemas install leaves out of production. The build fills in BUILD_MODE, so a production
// build drops this branch and the card's chunk.
const BUILD_MODE: string = '%{BUILD_MODE}%';
if (BUILD_MODE !== 'prod' && BUILD_MODE !== 'production') {
  void import('./@ns/public-ledger/dev/test-message.js').then(({ default: NSPublicLedgerTestMessage }) => {
    jobs['@ns/public-ledger-test-message'] = NSPublicLedgerTestMessage;
  });
}

export default jobs;
